var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "editor-text-cta-buttons-view" }, [
    _c(
      "button",
      {
        staticClass: "editor-cta-cancel-button",
        on: { click: _vm.onCancelClick },
      },
      [_vm._v(_vm._s(_vm.$t("views.editorTextCTA.cancel")))]
    ),
    _c(
      "button",
      {
        staticClass: "editor-cta-done-button",
        class: {
          "editor-cta-done-button-disabled": _vm.doneDisabled,
        },
        attrs: { disabled: _vm.doneDisabled },
        on: { click: _vm.onDoneClick },
      },
      [_vm._v(_vm._s(_vm.$t("views.editorTextCTA.done")))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }